import { useState, useEffect } from "react";

export default function DisplaySearch({
  fulldata,
  data,
  setData,
  selectedRarities,
  handleRarityChange,
  setSortOption,
}) {
  const [inputs, setInputs] = useState({});
  const [username, setUsername] = useState("");

  useEffect(() => {
    setUsername(localStorage.getItem("username") || "");
  }, []);

  const rarityOrder = [
    "common",
    "rare",
    "epic",
    "legendary",
    "limited",
    "exotic",
    "partner",
  ];

  const sortOptions = [
    "rarity",
    "alphabetical",
    "Number ID",
    ...(username ? ["owned", "unowned"] : []),
  ];

  function handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    const keyword = value.toLowerCase();

    if (name === "keyword") {
      const filteredResults = fulldata.filter(
        (item) =>
          item.name.toLowerCase().includes(keyword) ||
          item.rarity.toLowerCase().includes(keyword) ||
          item.obtain.join(",").toLowerCase().includes(keyword)
      );
      setData(filteredResults);
    }

    setInputs((values) => ({ ...values, [name]: value }));
  }

  const handleSortChange = (event) => {
    const newSortOption = event.target.value;
    setSortOption(newSortOption);
  };

  const rarityImages = {
    common: "singles-c",
    rare: "singles-r",
    limited: "singles-lm",
    epic: "singles-e",
    legendary: "singles-l",
    exotic: "singles-ex",
    partner: "singles-p",
  };

  return (
    <div className="search_container">
      <div className="cosmetic_display_search_wrapper">
        <div className="horizontal-center">
          <div className="cosmetic_display_search">
            <input
              name="keyword"
              type="text"
              onChange={handleChange}
              value={inputs.keyword || ""}
              placeholder="Search..."
              className="search-input"
            />
          </div>
          <div className="checkbox-horizontal">
            <div className="select-checkbox">
              <div className="white-button-header">
                <button
                  style={{ fontFamily: "Minecraft Seven", padding: 0 }}
                  className="white-button"
                >
                  <img
                    src="https://app.zeqa.net/image/toggles/filters.webp"
                    alt="Filters"
                    style={{
                      maxWidth: "40px",
                      maxHeight: "34px",
                      width: "auto",
                      height: "auto",
                    }}
                  />
                </button>
                <div className="toggle-dropdown">
                  {rarityOrder.map((rarity) => (
                    <div key={rarity} className="checkbox-container">
                      <input
                        type="checkbox"
                        id={`checkbox-${rarity}`}
                        value={rarity}
                        onChange={handleRarityChange}
                        checked={selectedRarities.includes(rarity)}
                      />
                      <label
                        htmlFor={`checkbox-${rarity}`}
                        className="checkbox"
                      >
                        <div
                          className={`unicode-sprite ${rarityImages[rarity]}`}
                        ></div>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="select-checkbox">
              <div className="white-button-header">
                <select
                  id="sort-dropdown"
                  className="white-button"
                  onChange={handleSortChange}
                  style={{
                    fontFamily: "Minecraft Seven",
                    padding: "8.5px",
                    cursor: "pointer",
                  }}
                >
                  {sortOptions.map((option) => (
                    <option key={option} value={option}>
                      {option.charAt(0).toUpperCase() + option.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
}
